import React from "react"
import './HalfGag.css'
import '@fontsource/roboto';
import Button from '@material-ui/core/Button';
import {faPlay} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getPosts} from "../../api/api_post";

export default class HalfGag extends React.Component {

    constructor(props) {
        super(props);

        const {isAdmin} = this.props
        // this.currentPageNumber = 1

        this.state = {
            isAdmin: isAdmin,
            apiPosts: [],
            apiCategories: [],
            lastPageNumber: 1
        }

        const {innerWidth: maxWidth, innerHeight: height} = window;
        this.maxWidth = maxWidth
        this.maxHeight = height

        // this.fetchMoreData = this.fetchMoreData.bind(this)
        this.goFunYourself = this.goFunYourself.bind(this)
    }

    componentDidMount() {
        document.body.className = 'body-halfgag';
        // login()
        this.getLastPageNumber()
    }

    getRandomImgPosition() {
        return {
            top: Math.random() * this.maxHeight + "px",
            left: Math.random() * this.maxWidth + "px",
            transform: "rotate(" + Math.random() * 45 * (Math.random() > 0.5 ? 1 : -1) + "deg)"
        }
    }

    getRandomArrayValues(array, numberElements) {
        var result = new Array(numberElements),
            len = array.length,
            taken = new Array(len);
        if (numberElements > len)
            throw new RangeError("getRandom: more elements taken than available");
        while (numberElements--) {
            var x = Math.floor(Math.random() * len);
            result[numberElements] = array[x in taken ? taken[x] : x];
            taken[x] = --len in taken ? taken[len] : len;
        }
        return result;
    }

    getLastPageNumber() {
        Promise.all([getPosts()]).then((promisesResults) => {
            const [posts] = promisesResults
            let lastPage = posts['hydra:view']['hydra:last'].split('=')
            lastPage = lastPage[lastPage.length - 1]
            this.setState({
                lastPageNumber: lastPage
            })
        })
    }

    goFunYourself() {
        this.props.history.push('/fun/' + this.state.lastPageNumber)
    }

    render() {

        const backgroundMemes = [
            "1hj6i2.jpg",
            "2b9qva.jpg",
            "2baxar.jpg",
            "2fhok.jpg",
            "2gycra.jpg",
            "2ji8hx.jpg",
            "3e6gaq.png",
            "3rsxfo.jpg",
            "8iqed.jpg",
            "18mq5r.jpg",
            "73sbv.jpg",
            "106nxw.jpg",
            "136hly.jpg",
            "1950s-Middle-Finger.jpg",
            "1990s-First-World-Problems.jpg",
            "Actual-Advice-Mallard.jpg",
            "Archer.jpg",
            "Batman-Slapping-Robin.jpg",
            "Boardroom-Meeting-Suggestion.jpg",
            "c2lry.jpg",
            "Confession-Bear.jpg",
            "Distracted-Boyfriend.jpg",
            "dkdeh.jpg",
            "Dwight-Schrute.jpg",
            "ere3z.jpg",
            "Grandma-Finds-The-Internet.jpg",
            "Heres-Johnny.jpg",
            "Insanity-Wolf.jpg",
            "LOL-Guy.jpg",
            "of959.jpg",
            "One-Does-Not-Simply.jpg",
            "Philosoraptor.jpg",
            "PPAP.jpg",
            "RPG-Fan.jpg",
            "Shrek-Cat.jpg",
            "Socially-Awesome-Awkward-Penguin.jpg",
            "Success-Kid.jpg",
            "Table-Flip-Guy.jpg",
            "They're-The-Same-Picture.jpg",
            "Troll-Face.jpg",
            "X-All-The-Y.jpg",
            "1c81c1.jpg",
            "5hygxy.jpg",
            "6emgw.jpg",
            "19vcz0.jpg",
            "Afraid-To-Ask-Andy.jpg",
            "Bad-Luck-Brian.jpg",
            "Brace-Yourselves-X-is-Coming.jpg",
            "But-Thats-None-Of-My-Business.jpg",
            "Drake-Hotline-Bling.jpg",
            "First-World-Problems.jpg",
            "I-Should-Buy-A-Boat-Cat.jpg",
            "Laughing-Leo.png",
            "Third-World-Skeptical-Kid.jpg",
            "This-Is-Fine.jpg",
            "Too-Damn-High.jpg",
            "Tuxedo-Winnie-The-Pooh.png",
            "Two-Buttons.jpg",
            "Woman-Yelling-At-Cat.jpg",
            "X-X-Everywhere.jpg",
        ]


        return <>
            <div className='title-div' style={{paddingTop: this.maxHeight / 4}}>
                <h1 className='main-title'>HalfGag</h1>
                <Button variant="contained" className="btn-go-fun" onClick={this.goFunYourself}>
                    Go fun yourself
                    <FontAwesomeIcon
                        className="btn-go-fun-fa"
                        icon={faPlay}
                        size="2x"
                    />
                </Button>
            </div>

            {/*RANDOM MEME PICTURES*/}
            {this.getRandomArrayValues(backgroundMemes, 10).map((backgroundMemeName, index) => {
                    const {
                        top: randomImgPositionTop,
                        left: randomImgPositionLeft,
                        transform: randomImgPositionTransform
                    } = this.getRandomImgPosition()

                    return <img
                        key={index}
                        alt={''}
                        src={process.env.PUBLIC_URL + '/memes/' + backgroundMemeName}
                        className="background-meme"
                        onMouseOver={(e) => {
                            const {
                                top: randomImgPositionTop,
                                left: randomImgPositionLeft,
                                transform: randomImgPositionTransform
                            } = this.getRandomImgPosition()

                            e.currentTarget.style.top = randomImgPositionTop
                            e.currentTarget.style.left = randomImgPositionLeft
                            e.currentTarget.style.transform = randomImgPositionTransform
                        }}
                        style={{
                            top: randomImgPositionTop,
                            left: randomImgPositionLeft,
                            transform: randomImgPositionTransform
                        }}
                    />
                }
            )}
        </>

    }
}